import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Brand } from "../Model/Brand";
import { BrandRepository } from "../Repository/BrandRepository";

export interface GetBrandUseCase {
  invoke: (page: number, size: number, search: string) => Promise<PaginationResult<Brand>>;
}

export class GetBrands implements GetBrandUseCase {
  private brandRepo: BrandRepository;
  constructor(_BrandRepo: BrandRepository) {
    this.brandRepo = _BrandRepo;
  }

  async invoke(page: number, size: number, search: string){
     
    const getData = await this.brandRepo.getBrands(page, size, search);
    return getData;
  }
}